<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          headline="Quản lý hóa đơn"
          :link="[{ text: 'Quản lý hóa đơn', href: '../bill' }]"
        />
      </div>
      <bill-create></bill-create>
    </div>
    <v-card class="pa-2 mx-md-2">
      <div class="py-1 text-right">
        <bill-filter-dialog @onFilter="refresh" v-if="$vuetify.breakpoint.xs" />
        <setting-table-header
          :default-headers="originHeaders"
          @change="headers = $event"
        />
        <KebapMenu v-if="!$vuetify.breakpoint.xs">
          <v-list>
            <v-list-item>
              <export-excel :custom-header="headers" api="/bills/" />
            </v-list-item>
          </v-list>
        </KebapMenu>
      </div>
      <v-data-table
        class="nowrap px-1"
        :headers="headers"
        :items="bills"
        :search="search"
        :loading="loading"
        :items-per-page="5"
        disable-sort
        select
        dense
      >
        <template v-slot:top>
          <bill-filter
            @onFilterChanged="refresh"
            v-if="!$vuetify.breakpoint.xs"
          />
        </template>
        <template v-slot:item.code="{ item }">
          <router-link to @click.native.stop="onView(item)">{{
            item.code
          }}</router-link>
        </template>
        <template v-slot:item.customerName="{ item }">
          <div>{{ item.customerName }}</div>
        </template>
        <template v-slot:item.customerPaid="{ item }">
          <div>{{ item.customerPaid | formatMoney }}</div>
        </template>
        <template v-slot:item.staff="{ item }">
          <staff-name :staff="item.staff"></staff-name>
        </template>
        <template v-slot:item.date="{ item }">
          <div>{{ item.date | familiarizeDate }}</div>
        </template>
        <template v-slot:item.provider="{ item }">
          <div>{{ item.provider }}</div>
        </template>
        <template v-slot:item.paymentType="{ item }">
          <div>{{ allPaymentTypes[item.paymentType] }}</div>
        </template>
        <template v-slot:item.type="{ item }">
          <div>{{ allBillTypes[item.type] }}</div>
        </template>
        <template v-slot:item.items="{ item }">
          <router-link
            v-for="data in item.items"
            :key="data.id"
            :to="'/bill/' + data.id"
            >{{ data.title }},</router-link
          >
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip :color="getColor(item.status)" small dark>{{
            allBillStatus[item.status]
          }}</v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon medium @click.stop="onRemove(item)">delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
    <bill-edit :bill="selected" :state="dialog" @updateBill="updateBill" />
    <bill-viewer :bill="selected" :state="viewDialog" @onEdit="onEdit" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import utils from '@/plugins/utils.js'
import moment from 'moment'
import BillFilter from '@/modules/bill/BillFilter'
import StaffName from '@/components/basic/card/CardStaffName'
import BillEdit from '@/modules/bill/BillEditDialog.vue'
import BillViewer from '@/modules/bill/BillPrintDialog.vue'
import BillCreate from '@/modules/bill/BillCreateDialog.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import SettingTableHeader from '@/components/basic/table/SettingHeaders'
import ExportExcel from '@/components/basic/ExportExcel'
import KebapMenu from '@/components/basic/menu/KebapMenu.vue'
import BillFilterDialog from '@/modules/bill/BillFilterDialog.vue'

const originHeaders = [
  {
    text: 'Mã Hóa Đơn',
    align: 'left',
    sortable: false,
    value: 'code',
    show: true,
  },
  { text: 'Tên người nộp tiền', value: 'customerName', show: true },
  { text: 'Số Tiền', align: 'right', value: 'customerPaid', show: true },
  { text: 'Loại', align: 'right', value: 'type', show: false },
  { text: 'Ngày lập hóa đơn', value: 'date', show: true },
  { text: 'Thanh Toán', value: 'paymentType', show: true },
  { text: 'Người lập hóa đơn', value: 'staff', show: true },
  { text: 'Hành động', value: 'actions', align: 'center', show: true },
]

export default {
  components: {
    BillCreate,
    BillFilter,
    StaffName,
    BillEdit,
    BillViewer,
    Breadcrumbs,
    SettingTableHeader,
    ExportExcel,
    KebapMenu,
    BillFilterDialog,
  },
  data() {
    return {
      search: '',
      expanded: [],
      loading: false,
      dialog: false,
      viewDialog: false,
      originHeaders: originHeaders,
      headers: [],
      draw: false,
      billId: '',
      selected: null,
      dialogBillFilter: false,
    }
  },
  computed: {
    ...mapGetters('bill', ['bills', 'bill']),
    ...mapState('constant', [
      'billStatus',
      'billTypes',
      'paymentTypes',
      'billTypes',
    ]),
    ...mapGetters('app', ['department']),
    allBillStatus() {
      return this.billStatus.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title'],
        }),
        {}
      )
    },
    allPaymentTypes() {
      return this.paymentTypes.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.status]: cur.title,
        }),
        {}
      )
    },
    allBillTypes() {
      return this.billTypes.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.status]: cur.title,
        }),
        {}
      )
    },
    billData() {
      return this.bill(this.billId)
    },
    total() {
      return (
        this.bills.reduce((total, bill) => {
          return total + bill.customerPaid
        }, 0) || 0
      )
    },
  },
  methods: {
    ...mapActions('bill', [
      'fetchBills',
      'fetchLead',
      'updateLead',
      'setBill',
      'updateBill',
      'removeBill',
    ]),
    onBillSelected(bill) {
      this.expanded = []
      if (this.billId !== bill.id) {
        this.expanded.push(bill)
        this.billId = bill.id
      } else {
        this.billId = ''
      }
    },
    updateDraw(state) {
      this.draw = state
    },
    onRemove(bill) {
      this.$dialog.confirm({
        title: 'Xóa Hóa đơn này?',
        text: 'Bạn có chắc chắn muốn xóa hóa đơn này. Dữ liệu này sau khi xóa sẽ không thể phục hồi. Bạn có chắn chắn?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeBill(bill.id)
          await this.updateLeads(bill)
        },
      })
    },
    async updateLeads(bill) {
      if (!bill.lead) return
      const lead = await this.fetchLead(bill.lead.id)
      const bills = lead.bills.filter((b) => b !== bill.id)
      const customerPaid = bills.reduce((acc, cur) => acc + cur.customerPaid, 0)
      const liabilities = lead.total - customerPaid
      await this.updateLead({
        id: lead.id,
        customerPaid,
        liabilities,
        status: liabilities > 0 ? 'liabilities' : 'paid',
      })
    },
    onEdit(bill) {
      this.selected = bill
      this.dialog = !this.dialog
    },
    onCreate(bill) {},
    onView(bill) {
      this.selected = bill
      this.viewDialog = !this.viewDialog
    },
    async refresh(query) {
      this.loading = true
      try {
        await this.fetchBills({
          ...query,
          _limit: -1,
          _sort: 'createdAt:desc',
        })
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    getColor(status) {
      if (status === 'approved') return 'green'
      else if (status === 'rejected') return 'red'
      else if (status === 'opened') return 'blue'
      else if (status === 'canceled') return 'orange'
      else return 'gray'
    },
  },
  async mounted() {
    if (this.bills.length === 0) {
      await this.refresh('')
    }
  },
  filters: {
    familiarizeDate: (time) => {
      if (!time) {
        return 'Không có thông tin'
      }
      return moment(time).format('DD/MM/YYYY')
    },
    SimplizedDate: (time) => {
      if (!time) {
        return 'Không có thông tin'
      }
      return moment(time).format('DD/MM')
    },
    formatMoney(data) {
      return utils.formatMoney(data)
    },
  },
}
</script>

<style>
.v-select__level-sale {
  font-size: 1em;
  border: none;
}
.content {
  margin: 0 !important;
  padding: 0 !important;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  width: 100%;
}
.border {
  border: solid 1px lightgray;
  border-radius: 4px;
}
.border-right {
  border-right: solid 1px lightgray;
}
</style>
